var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Box, Button, Grid, IconButton, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { BubbleChatIcon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetDocumentFilterMutation } from '../../../../application/features/chat/chat-api';
import { useLazyGetDocumentsByModelNumberQuery } from '../../../../application/features/folder-view/folder-view-api';
import { DocumentProcessingStatus } from '../../../../application/features/machine-documents/enums/document-processing-status';
import { MachineDocumentUploadingStatus } from '../../../../application/features/machine-documents/enums/machine-document-uploading-status';
import { useDeleteSingleModelMutation, useFindMachineMutation, useLazyGetMachineClientsSerialsQuery, useLazyGetModelsQuery, useLazyGetModelsWithDocumentsQuery } from '../../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ConfirmDialog from '../../../components/ConfirmDialog';
import MachineDocuments from '../../../components/MachineDocuments';
import ClientSerialDrawer from '../serial-numbers/client-and-serial';
import ActivationDialog from './activation-dialog';
import EditModel from './edit-model-serials/EditModel';
import OthersCard from './OthersCard';
import OthersFolder from './OthersFolder';
import SubFolderCard from './SubFolderCard';
import SubFolderContent from './SubFolderContent';
var CHAT_START_LOCATION = 'Assets';
var Subfolder = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var machineId = _a.machineId, machineName = _a.machineName, onSubfolderSelect = _a.onSubfolderSelect, mainFolderContent = _a.mainFolderContent, setOtherBreadCrumbPath = _a.setOtherBreadCrumbPath, selectedOthersFolderId = _a.selectedOthersFolderId, searchText = _a.searchText, isFetchingSubContent = _a.isFetchingSubContent, sortFieldSubFolder = _a.sortFieldSubFolder, sortFieldDirectionSubFolder = _a.sortFieldDirectionSubFolder;
    var _h = useTranslate(), translate = _h.translate, tWithField = _h.tWithField;
    var theme = useTheme();
    var navigate = useNavigate();
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var _j = __read(useState(null), 2), selectedSubfolderId = _j[0], setSelectedSubfolderId = _j[1];
    var _k = __read(useState(null), 1), selectedMachine = _k[0];
    var _l = __read(useState(false), 2), dialogOpen = _l[0], setDialogOpen = _l[1];
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isXs = useMediaQuery('(max-width:600px)');
    var _m = __read(useLazyGetDocumentsByModelNumberQuery(), 2), triggerDocuments = _m[0], documentList = _m[1].data;
    var _o = __read(useState([]), 2), originalResults = _o[0], setOriginalResults = _o[1];
    var _p = __read(useState([]), 2), filteredResults = _p[0], setFilteredResults = _p[1];
    var _q = __read(useState([]), 2), selectedEditModelData = _q[0], setSelectedEditModelData = _q[1];
    var _r = __read(useState(searchText), 2), debouncedValue = _r[0], setDebouncedValue = _r[1];
    var _s = __read(useState(false), 2), machineDocumentsModalOpen = _s[0], setMachineDocumentsModalOpen = _s[1];
    var _t = __read(useState(false), 2), editModelsOpen = _t[0], setEditModelsOpen = _t[1];
    var _u = __read(useFindMachineMutation(), 2), triggerGetMachine = _u[0], _v = _u[1], machine = _v.data, isMachineLoading = _v.isLoading, isSuccess = _v.isSuccess;
    var _w = __read(useState([]), 2), selectedDocuments = _w[0], setSelectedDocuments = _w[1];
    var _x = __read(useState(false), 2), deleteConfirmOpen = _x[0], setDeleteConfirmOpen = _x[1];
    var _y = __read(useState(), 2), selectedMachineModel = _y[0], setSelectedMachineModel = _y[1];
    var _z = __read(useState(false), 2), showOthersContent = _z[0], setShowOthersContent = _z[1];
    var _0 = __read(useState({ isOpen: false }), 2), viewClientSerials = _0[0], setViewClientSerials = _0[1];
    var _1 = __read(useSetDocumentFilterMutation(), 2), setDocumentsFilter = _1[0], documentFilterLoading = _1[1].isLoading;
    var _2 = __read(useLazyGetMachineClientsSerialsQuery(), 2), triggerGetClientSerials = _2[0], clientSerials = _2[1].data;
    var _3 = __read(useLazyGetModelsQuery(), 2), getMachineModels = _3[0], machineModels = _3[1].data;
    var _4 = __read(useLazyGetModelsWithDocumentsQuery(), 2), getModelsWithDocuments = _4[0], _5 = _4[1].data, modelsWithDocuments = _5 === void 0 ? [] : _5;
    var _6 = __read(useDeleteSingleModelMutation(), 2), triggerDeleteModel = _6[0], isDeleteSuccess = _6[1].isSuccess;
    var showMachineDocuments = machineDocumentsModalOpen && !isMachineLoading && !!machine;
    var deleteConfirmTitle = translate('assets.deleteModel');
    var deleteConfirmContent = translate('assets.deleteModelText');
    var deleteConfirmWarning = translate('assets.deleteModelWarning');
    var confirmHtmlContent = useMemo(function () {
        return (_jsx(Fragment, { children: !!modelsWithDocuments.length && (_jsxs(Box, { mt: 2, children: [_jsx(Typography, { variant: 'body2', children: deleteConfirmWarning }), _jsx(List, { sx: { pt: 0 }, children: modelsWithDocuments.map(function (model) { return (_jsx(ListItem, { sx: { pl: 0, pb: 0 }, children: _jsx(ListItemText, { children: model }) }, model)); }) })] })) }));
    }, [deleteConfirmWarning, modelsWithDocuments]);
    var handleSubfolderClick = function (sub) {
        onSubfolderSelect(sub);
        setSelectedSubfolderId(sub);
    };
    useEffect(function () {
        if (machineId)
            getMachineModels(machineId);
    }, [machineId, getMachineModels]);
    useEffect(function () {
        var _a;
        if ((_a = machineModels === null || machineModels === void 0 ? void 0 : machineModels.models) === null || _a === void 0 ? void 0 : _a.length) {
            var uniqueModelNumbers = __spreadArray([], __read(new Set(machineModels.models.map(function (model) { return model.modelNumber; }))), false);
            setOriginalResults(uniqueModelNumbers);
            setFilteredResults(uniqueModelNumbers);
        }
        else {
            setOriginalResults([]);
            setFilteredResults([]);
        }
    }, [machineModels]);
    useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(searchText);
        }, 1000);
        return function () {
            clearTimeout(handler);
        };
    }, [searchText]);
    useEffect(function () {
        if (machineId) {
            triggerDocuments(machineId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [machineId]);
    useEffect(function () {
        var e_1, _a;
        var results = __spreadArray([], __read(originalResults), false);
        // Step 1: Apply search filter
        if (debouncedValue && debouncedValue.length >= 2) {
            var keywords_1 = debouncedValue.toLowerCase().split(' ').filter(Boolean);
            results = results.filter(function (item) {
                var itemText = item.toLowerCase();
                return keywords_1.some(function (keyword) { return itemText.includes(keyword); });
            });
        }
        // Step 2: Map model counts
        var modelCountMap = {};
        if (documentList) {
            try {
                for (var documentList_1 = __values(documentList), documentList_1_1 = documentList_1.next(); !documentList_1_1.done; documentList_1_1 = documentList_1.next()) {
                    var doc = documentList_1_1.value;
                    var model = doc.modelNumber;
                    modelCountMap[model] = (modelCountMap[model] || 0) + 1;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (documentList_1_1 && !documentList_1_1.done && (_a = documentList_1.return)) _a.call(documentList_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // Step 3: Apply sorting
        if (sortFieldSubFolder === 'Documents') {
            results.sort(function (a, b) {
                var countA = modelCountMap[a] || 0;
                var countB = modelCountMap[b] || 0;
                return sortFieldDirectionSubFolder === 'asc' ? countA - countB : countB - countA;
            });
        }
        else if (sortFieldSubFolder === 'ModelNumber') {
            results.sort(function (a, b) {
                return sortFieldDirectionSubFolder === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
            });
        }
        // Step 4: Update results
        setFilteredResults(results);
    }, [
        debouncedValue,
        sortFieldSubFolder,
        sortFieldDirectionSubFolder,
        documentList,
        originalResults
    ]);
    useEffect(function () {
        if (isSuccess)
            setMachineDocumentsModalOpen(true);
    }, [isSuccess]);
    useEffect(function () {
        if (isDeleteSuccess) {
            enqueueSnackbar(tWithField('toolTips.deleteSuccess', 'common.modelNumber'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            setSelectedMachineModel(undefined);
            setDeleteConfirmOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDeleteSuccess]);
    if (selectedSubfolderId) {
        return (_jsx(SubFolderContent, { machineId: machineId, subfolderId: machineName, subFolderContents: [], onBack: function () { return setSelectedSubfolderId(null); }, searchText: searchText, isFetchingSubContent: isFetchingSubContent }));
    }
    var handleCloseModelsEdit = function () {
        setEditModelsOpen(false);
        setSelectedEditModelData([]);
    };
    var handleStartChat = function (model) {
        if (model) {
            triggerGetMachine({ id: machineId, modelNumber: model });
        }
        else {
            triggerGetMachine({ id: machineId, modelNumber: translate('common.others') });
        }
    };
    var handleViewClients = function (model) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            triggerGetClientSerials({ machineId: machineId, modelNumber: model });
            setViewClientSerials({ isOpen: true, model: model });
            return [2 /*return*/];
        });
    }); };
    var handleEditModel = function (model) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSelectedEditModelData(machineModels === null || machineModels === void 0 ? void 0 : machineModels.models.filter(function (x) { return x.modelNumber === model; }));
            setEditModelsOpen(true);
            return [2 /*return*/];
        });
    }); };
    var handleDeleteConfirmation = function (model) { return __awaiter(void 0, void 0, void 0, function () {
        var serialNumbers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    serialNumbers = machineModels === null || machineModels === void 0 ? void 0 : machineModels.models.filter(function (x) { return x.modelNumber === model; }).flatMap(function (x) { return x.serialNumbers || []; });
                    return [4 /*yield*/, getModelsWithDocuments({
                            machineId: machineId,
                            models: [
                                {
                                    modelNumber: model,
                                    serialNumbers: serialNumbers
                                }
                            ]
                        }).unwrap()];
                case 1:
                    _a.sent();
                    setSelectedMachineModel(machineModels === null || machineModels === void 0 ? void 0 : machineModels.models.filter(function (x) { return x.modelNumber === model; }));
                    setDeleteConfirmOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteModel = function () {
        if (selectedMachineModel) {
            var request = {
                machineId: machineId,
                clients: selectedMachineModel
                    .filter(function (x) { return x.clientId !== null; })
                    .map(function (model) { return model.clientId; }),
                modelNumber: selectedMachineModel[0].modelNumber
            };
            triggerDeleteModel(request);
        }
    };
    var handleConfirmToggle = function () {
        setDialogOpen(false);
    };
    var handleSelectToggle = function (id) {
        setSelectedDocuments(function (prev) {
            return prev.includes(id) ? prev.filter(function (item) { return item !== id; }) : __spreadArray(__spreadArray([], __read(prev), false), [id], false);
        });
    };
    var startDocumentsChat = function () { return __awaiter(void 0, void 0, void 0, function () {
        var conversation_id, documentsFilter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    conversation_id = nanoid();
                    documentsFilter = {
                        conversation_id: conversation_id,
                        user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId,
                        user_name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
                        chat_start_location: CHAT_START_LOCATION,
                        documents: selectedDocuments,
                        company_id: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id
                    };
                    return [4 /*yield*/, setDocumentsFilter(documentsFilter).unwrap()];
                case 1:
                    _a.sent();
                    navigate('/chats');
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOthersFolderClick = function () {
        if (mainFolderContent && mainFolderContent.length > 0) {
            setShowOthersContent(true);
            setOtherBreadCrumbPath();
        }
    };
    if (showOthersContent && selectedOthersFolderId != null) {
        return (_jsx(Box, { sx: {
                height: __assign(__assign(__assign(__assign({ xs: selectedDocuments.length > 0 ? 'calc(100svh - 476px)' : 'calc(100svh - 293px)', sm: 'calc(100svh - 416px)' }, (isscreen600900 && { sm: 'calc(100svh - 416px)' })), (isscreen600900Landscape && { sm: '400px' })), (isscreen9001200Landscape
                    ? { sm: '420px' }
                    : iscreen9001200
                        ? { sm: 'calc( 100svh - 350px)' }
                        : {})), { overflowY: 'auto' })
            }, children: _jsxs(Grid, { container: true, spacing: 2, px: 0.5, children: [selectedDocuments.length > 0 && !isXs && (_jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Typography, { variant: 'body1', color: 'text.secondary', children: [selectedDocuments.length, " ", translate('knowledge.selected')] }), _jsx(IconButton, { size: 'medium', color: 'primary', onClick: startDocumentsChat, disabled: documentFilterLoading, children: _jsx(BubbleChatIcon, {}) })] }) })), selectedDocuments.length >= 1 && isXs && (_jsx(Box, { position: 'fixed', width: '90%', bottom: 100, left: '50%', sx: {
                            transform: 'translateX(-50%)',
                            backgroundColor: 'rgba(33, 43, 54, 1)',
                            boxShadow: '0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33',
                            borderRadius: theme.spacing(1.5),
                            p: theme.spacing(1),
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            zIndex: 1
                        }, children: _jsxs(Box, { display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 1, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', children: [_jsx(IconButton, { size: 'Xs', style: { color: '#919EAB' }, onClick: function () { return setSelectedDocuments([]); }, children: _jsx(Icon, { icon: 'mingcute:close-line' }) }), _jsxs(Typography, { variant: 'subtitle2', fontWeight: 600, color: '#C4CDD5', children: [selectedDocuments.length, " ", translate('knowledge.selected')] })] }), _jsx(Button, { size: 'small', endIcon: _jsx(BubbleChatIcon, { width: 16, height: 16 }), variant: 'contained', color: 'primary', onClick: startDocumentsChat, disabled: documentFilterLoading, children: translate('knowledge.startChat') })] }) })), mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.map(function (other) { return (_jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 4, md: iscreen9001200 ? 6 : 4 }, children: _jsx(OthersCard, { id: other.id, title: other.newFileName, disabled: !other.addedToKnowledgeBase, uploadingStatus: other.uploadingStatus, processingStatus: other.processingStatus, addedToKnowledgeBase: other.addedToKnowledgeBase, pdfFilePath: other.filePath, isSelected: selectedDocuments.includes(other.id), onToggleSelect: handleSelectToggle }) }, other.id)); })] }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                    height: __assign(__assign(__assign(__assign({ xs: selectedDocuments.length > 0 ? 'calc(100svh - 476px)' : 'calc(100svh - 293px)', sm: 'calc(100svh - 416px)' }, (isscreen600900 && { sm: 'calc(100svh - 416px)' })), (isscreen600900Landscape && { sm: '400px' })), (isscreen9001200Landscape
                        ? { sm: '420px' }
                        : iscreen9001200
                            ? { sm: 'calc( 100svh - 350px)' }
                            : {})), { overflowY: 'auto' })
                }, children: _jsxs(Grid, { container: true, spacing: 2, px: 0.5, children: [filteredResults.length <= 0 && mainFolderContent && mainFolderContent.length <= 0 && (_jsx(Grid, { size: { xs: 12 }, sx: { textAlign: 'center', mt: 2 }, children: _jsx(Typography, { variant: 'subtitle1', children: translate('common.noRecordFound') }) })), selectedDocuments.length > 0 && !isXs && (_jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Typography, { variant: 'body1', color: 'text.secondary', children: [selectedDocuments.length, " ", translate('knowledge.selected')] }), _jsx(IconButton, { size: 'medium', color: 'primary', onClick: startDocumentsChat, disabled: documentFilterLoading, children: _jsx(BubbleChatIcon, {}) })] }) })), selectedDocuments.length >= 1 && isXs && (_jsx(Box, { position: 'fixed', width: '90%', bottom: 100, left: '50%', sx: {
                                transform: 'translateX(-50%)',
                                backgroundColor: 'rgba(33, 43, 54, 1)',
                                boxShadow: '0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33',
                                borderRadius: theme.spacing(1.5),
                                p: theme.spacing(1),
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                zIndex: 1
                            }, children: _jsxs(Box, { display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 1, children: [_jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', children: [_jsx(IconButton, { size: 'Xs', style: { color: '#919EAB' }, onClick: function () { return setSelectedDocuments([]); }, children: _jsx(Icon, { icon: 'mingcute:close-line' }) }), _jsxs(Typography, { variant: 'subtitle2', fontWeight: 600, color: '#C4CDD5', children: [selectedDocuments.length, " ", translate('knowledge.selected')] })] }), _jsx(Button, { size: 'small', endIcon: _jsx(BubbleChatIcon, { width: 16, height: 16 }), variant: 'contained', color: 'primary', onClick: startDocumentsChat, disabled: documentFilterLoading, children: translate('knowledge.startChat') })] }) })), filteredResults.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Grid, { size: { xs: 12 }, children: _jsx(Typography, { variant: 'subtitle1', children: translate('assets.folders') }) }), filteredResults.map(function (sub, index) { return (_jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 4, md: iscreen9001200 ? 6 : 4 }, children: _jsx(SubFolderCard, { title: sub, docCount: (function () {
                                            var _a, _b, _c, _d;
                                            var doc = documentList === null || documentList === void 0 ? void 0 : documentList.find(function (x) { return x.modelNumber.toLocaleLowerCase() === sub.toLocaleLowerCase(); });
                                            return (((_a = doc === null || doc === void 0 ? void 0 : doc.processedDocumentCount) !== null && _a !== void 0 ? _a : 0) +
                                                ((_b = doc === null || doc === void 0 ? void 0 : doc.failedDocumentCount) !== null && _b !== void 0 ? _b : 0) +
                                                ((_c = doc === null || doc === void 0 ? void 0 : doc.unprocessableDocumentCount) !== null && _c !== void 0 ? _c : 0) +
                                                ((_d = doc === null || doc === void 0 ? void 0 : doc.processingDocumentCount) !== null && _d !== void 0 ? _d : 0));
                                        })(), processedDocumentCount: (function () {
                                            var _a;
                                            var doc = documentList === null || documentList === void 0 ? void 0 : documentList.find(function (x) { return x.modelNumber.toLocaleLowerCase() === sub.toLocaleLowerCase(); });
                                            return (_a = doc === null || doc === void 0 ? void 0 : doc.processedDocumentCount) !== null && _a !== void 0 ? _a : 0;
                                        })(), failedDocumentCount: (function () {
                                            var _a;
                                            var doc = documentList === null || documentList === void 0 ? void 0 : documentList.find(function (x) { return x.modelNumber.toLocaleLowerCase() === sub.toLocaleLowerCase(); });
                                            return (_a = doc === null || doc === void 0 ? void 0 : doc.failedDocumentCount) !== null && _a !== void 0 ? _a : 0;
                                        })(), unprocessableDocumentCount: (function () {
                                            var _a;
                                            var doc = documentList === null || documentList === void 0 ? void 0 : documentList.find(function (x) { return x.modelNumber.toLocaleLowerCase() === sub.toLocaleLowerCase(); });
                                            return (_a = doc === null || doc === void 0 ? void 0 : doc.unprocessableDocumentCount) !== null && _a !== void 0 ? _a : 0;
                                        })(), processingDocumentCount: (function () {
                                            var _a;
                                            var doc = documentList === null || documentList === void 0 ? void 0 : documentList.find(function (x) { return x.modelNumber.toLocaleLowerCase() === sub.toLocaleLowerCase(); });
                                            return (_a = doc === null || doc === void 0 ? void 0 : doc.processingDocumentCount) !== null && _a !== void 0 ? _a : 0;
                                        })(), onClick: function () { return handleSubfolderClick(sub); }, onStartChat: function () { return handleStartChat(sub); }, onViewClients: function () { return handleViewClients(sub); }, onEditMachine: function () { return handleEditModel(sub); }, onDeleteMachine: function () { return handleDeleteConfirmation(sub); } }) }, "".concat(sub, "-").concat(index))); })] })), _jsxs(_Fragment, { children: [_jsx(Grid, { size: { xs: 12 }, children: _jsx(Typography, { variant: 'subtitle1', children: translate('common.others') }) }), _jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 4, md: iscreen9001200 ? 6 : 4 }, children: _jsx(OthersFolder, { title: translate('common.others'), docCount: (_b = mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.length) !== null && _b !== void 0 ? _b : 0, processedDocumentCount: (_c = mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.filter(function (doc) {
                                            return doc.addedToKnowledgeBase === true &&
                                                doc.uploadingStatus === MachineDocumentUploadingStatus.Success &&
                                                doc.processingStatus === DocumentProcessingStatus.Success;
                                        }).length) !== null && _c !== void 0 ? _c : 0, failedDocumentCount: (_d = mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.filter(function (doc) {
                                            return doc.addedToKnowledgeBase === false &&
                                                (doc.uploadingStatus === MachineDocumentUploadingStatus.Failed ||
                                                    doc.processingStatus === DocumentProcessingStatus.RetryableFailure);
                                        }).length) !== null && _d !== void 0 ? _d : 0, unprocessableDocumentCount: (_e = mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.filter(function (doc) {
                                            return doc.addedToKnowledgeBase === false &&
                                                doc.uploadingStatus === MachineDocumentUploadingStatus.Success &&
                                                doc.processingStatus === DocumentProcessingStatus.NonRetryableFailure;
                                        }).length) !== null && _e !== void 0 ? _e : 0, processingDocumentCount: (_f = mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.filter(function (doc) {
                                            return doc.addedToKnowledgeBase === false &&
                                                doc.uploadingStatus === MachineDocumentUploadingStatus.Success &&
                                                doc.processingStatus === DocumentProcessingStatus.NotProcessed;
                                        }).length) !== null && _f !== void 0 ? _f : 0, details: "".concat(mainFolderContent === null || mainFolderContent === void 0 ? void 0 : mainFolderContent.length, " Documents"), onClick: function () { return handleOthersFolderClick(); }, onStartChat: handleStartChat }) })] })] }) }), _jsx(ActivationDialog, { open: dialogOpen, onClose: function () { return setDialogOpen(false); }, onConfirm: handleConfirmToggle, machineName: (selectedMachine === null || selectedMachine === void 0 ? void 0 : selectedMachine.name) || '', isActivating: false }), showMachineDocuments && (_jsx(MachineDocuments, { machine: machine, isOpen: machineDocumentsModalOpen, setIsOpen: setMachineDocumentsModalOpen, onStartChat: function () { return setMachineDocumentsModalOpen(false); } })), editModelsOpen && machineId && selectedEditModelData && (_jsx(EditModel, { onClose: handleCloseModelsEdit, open: editModelsOpen, machineId: machineId, machineModels: selectedEditModelData })), clientSerials && (_jsx(ClientSerialDrawer, { isOpen: viewClientSerials.isOpen, onClose: function () { return setViewClientSerials({ isOpen: false, model: '' }); }, clientsSerialNumbers: clientSerials, machineName: machineName, machineModel: (_g = viewClientSerials === null || viewClientSerials === void 0 ? void 0 : viewClientSerials.model) !== null && _g !== void 0 ? _g : '' })), _jsx(ConfirmDialog, { open: deleteConfirmOpen, onClose: function () { return setDeleteConfirmOpen(false); }, onConfirm: handleDeleteModel, title: deleteConfirmTitle, content: deleteConfirmContent, htmlContent: confirmHtmlContent, confirmButtonText: translate('actions.confirm'), closeButtonText: translate('actions.cancel') })] }));
};
export default Subfolder;
